import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import './ConfirmationModal.scss';
import Button from '../Button/Button';

const ConfirmationModal = ({ id, isOpen, handleClose, header, message }) => {
    return (
        <>
            {isOpen &&
                <Modal id={id} isOpen={isOpen} handleClose={handleClose} size="sm">
                    <div className='confirm-modal'>
                        <h2>{header}</h2>
                        <p>{message}</p>
                        <Button id={`${id}-close-btn`} className='btn--rounded btn--blue-light btn--close'
                            onClick={() => handleClose()}
                        >
                            Close
                        </Button>
                    </div>
                </Modal>
            }
        </>
    )
}

ConfirmationModal.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    header: PropTypes.string,
    message: PropTypes.string
}

export default ConfirmationModal;